<template>

    <div class="outer-wrapper">

        <div v-if=" allLocations.length < 1 && isLoading ">

        </div>
        <div v-else>

            <div class="currently">

                <p class="merchant-name">{{ currentMerchant.name }}</p>
                <p class="merchant-location">{{ currentLocation != null ? currentLocation.name : '' }}</p>
            </div>

            <div class="locations-list">

                <!-- <div class="each-location card-wrap" v-for=" ( location, locKey ) in allLocations " :key=" locKey ">
                    <div @click=" selectLocation( location ) ">

                        <div class="location-image-wrapper">

                            <img :src=" location.imageName ? imageUrl + location.imagePath + '/' + location.imageName : 'https://via.placeholder.com/300x200' " class="location-image"/>
                        </div>
                        <p class="location-name">{{ location.name || 'add location name' }}</p>
                    </div>
                </div> -->
                <div v-for=" ( location, locKey ) in allLocations " :key=" locKey ">
                    <div :class=" locationClasses( location ) " @click=" selectLocation( location ) ">

                        <img class="location-image" :src=" location.imageName ? imageUrl + location.imagePath + '/' + location.imageName : '../../../img/logo.jpg' "/>
                        <p class="location-name">{{ location.name || 'add location name' }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'select-location',
        computed: {

            ...mapGetters({

                needsLocations  : 'merchant/needsLocations',
                locationError   : 'merchant/locationError',
                allLocations    : 'merchant/allLocations',
                currentMerchant : 'merchant/currentMerchant',
                currentLocation : 'merchant/currentLocation',
                previousRoute   : 'previousRoute',
                imageUrl        : 'imageUrl',
                isLoading       : 'isLoading',
            })
        },
        methods: {

            selectLocation( location ){

                // console.log( 'selecting location api call...' );

                if( parseInt( location.acceptingOrders ) == 0 ){

                } else if( this.currentLocation != null && location.locationId == this.currentLocation.locationId ){

                    // in this case, user navigated to the location page and selected the location they were already on..
                    // so just go back to the menu..
                    this.$router.push( { name: this.previousRoute.name } );
                } else if( this.currentLocation != null ) {

                    // in this case, the user was previously in a location and is now choosing a new location
                    // so reset the 'needs location' flag in orderMenu to refresh all stored menu data and trigger the api call
                    const options = {

                        refreshMenu : true,
                        location
                    };
                    this.$store.dispatch( 'merchant/selectLocation', options );
                } else {

                    const options = {

                        refreshMenu : false,
                        location
                    };
                    // in this case, the user has no current location, which means this is the first time coming here
                    // so there is no need to reset any data, the 'needs menu' flag is already set
                    this.$store.dispatch( 'merchant/selectLocation', options );
                }
            },
            locationClasses( location ){

                const base = [ 'location-tab' ];
                base.push( parseInt( location.acceptingOrders ) == 0 ? 'disabled-location' : '' )
                return base.join( ' ' );
            }
        },

        created(){

            console.log( 'getting all locations api call...' );
            this.$store.dispatch( 'merchant/getLocations' );
        }
    }

</script>

<style scoped>

    .locations-list {

        position: relative;
    }

    .outer-wrapper {

        min-height: 100%;
    }
    .currently {

        text-align: center;
        margin: 30px 0 40px;
    }

    .merchant-name {

        font-size: 1.6rem;
        font-weight: bold;
        margin: 0 0 5px;
    }
    .merchant-location {

        font-size: 1rem;
        font-weight: bold;
        margin: 0;
    }

    .location-tab {

        display: flex;
        align-items: center;
        justify-content: flex-start;

        padding: 20px 10px;
    }

    .location-name {

        display: flex;
        align-items: center;

        margin: 0;
        font-weight: bold;
        font-size: 1.3rem;
        padding: 5px 0px 0px 15px;
        background-color: white;
        width: 100%;
        height: 50px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        box-shadow: 2px 3px 2px 1px #ccc;
    }
    .location-image {

        position: relative;
        left: 10px;
        border-radius: 50%;
        width: 100px;
        height: 100px;
        box-shadow: -2px 3px 2px 0px #ccc;
    }

    .disabled-location {

        cursor: not-allowed;
    }

    .disabled-location > .location-name,
    .disabled-location > .location-image {

        opacity: 0.6;
    }

    .disabled-location::after {

        content: 'location disabled';
        position: absolute;
        bottom: 20px;
        text-align: center;
        width: 100%;
        left: 30px;
        font-size: 18px;
        font-weight: 400;
        color: red;
    }
</style>